function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */

import React, { useContext, useState, useEffect } from "react";
import { i18nContext, servicesContext } from "../table-context";
import { format } from "../../../utils/locales";
import propertyUtils from "../../../utils/property-util";
import AppConfigIntegrationSelect from "./AppConfig/AppConfigIntegrationSelect";
import AppConfigEnvironmentValue from "./AppConfig/AppConfigEnvironmentValue";
import AppConfigCollectionValue from "./AppConfig/AppConfigCollectionValue";
import AppConfigOptionsSelect from "./AppConfig/AppConfigOptionsSelect";
import AppConfigPropertySelect from "./AppConfig/AppConfigPropertySelect";
import AppConfigFeatureSelect from "./AppConfig/AppConfigFeatureSelect";
import { APP_CONFIG_FEATURE, APP_CONFIG_INTEGRATION, APP_CONFIG_OPTION, APP_CONFIG_OPTION_PROP, APP_CONFIG_OPTION_FEATURE, APP_CONFIG_PROPERTY } from "../Constants";
export default function AppConfigContent(_ref) {
  var isLoadingToolchainServices = _ref.isLoadingToolchainServices,
    property = _ref.property,
    updateProperty = _ref.updateProperty;
  var i18n = useContext(i18nContext);
  var toolchainServices = useContext(servicesContext);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    integrationProperty = _useState2[0],
    setIntegrationProperty = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    environmentProperty = _useState4[0],
    setEnvironmentProperty = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    collectionProperty = _useState6[0],
    setCollectionProperty = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    optionsProperty = _useState8[0],
    setOptionsProperty = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    propProperty = _useState0[0],
    setPropProperty = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    featureProperty = _useState10[0],
    setFeatureProperty = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isInit = _useState12[0],
    setIsInit = _useState12[1];
  var appConfigProperty = "{appconfig::${service}.${option}.${value}}";
  var findSelectedItem = function findSelectedItem(itemProperty, items) {
    var selected = null;
    if (itemProperty.value) {
      var selectedService = items.find(function (item) {
        return item.id === itemProperty.value;
      });
      selected = selectedService ? {
        id: selectedService.id,
        text: selectedService.text
      } : {
        id: property.value,
        text: format(i18n.messages.integrationRemoved, [itemProperty.value])
      };
    }
    return selected;
  };
  useEffect(function () {
    // In nested panels use case, editing an AppConfig was broken when this useEffect was called only on mount
    // Now for the edit use case, this useEffect watches for the first time "property" is altered and runs the initialisation steps
    // The "isInit" state ensures that the initialisation steps are only run once
    // This pattern is also followed in EnumContent

    if (!isInit && property.type && property.value) {
      var _appConfigIntegration, _appConfigIntegration2;
      // Should only be run when editing an existing AppConfig property
      setIsInit(true);
      var propertyString = property.value.split("::")[1].replace(/[{}]/g, "");
      var propertyArray = propertyString.split(".");
      var serviceId = propertyArray[0];
      var appConfigIntegration = propertyUtils.findSelectedIntegration({
        value: serviceId
      }, toolchainServices);
      var environmentId = (appConfigIntegration === null || appConfigIntegration === void 0 || (_appConfigIntegration = appConfigIntegration.parameters) === null || _appConfigIntegration === void 0 ? void 0 : _appConfigIntegration["environment-name"]) || "";
      var collectionId = (appConfigIntegration === null || appConfigIntegration === void 0 || (_appConfigIntegration2 = appConfigIntegration.parameters) === null || _appConfigIntegration2 === void 0 ? void 0 : _appConfigIntegration2["collection-name"]) || "";
      var optionId = propertyArray[1];
      var optionValue = propertyArray[2];
      setIntegrationProperty(_objectSpread(_objectSpread({}, integrationProperty), {}, {
        value: serviceId
      }));
      setEnvironmentProperty(_objectSpread(_objectSpread({}, environmentProperty), {}, {
        value: environmentId
      }));
      setCollectionProperty(_objectSpread(_objectSpread({}, collectionProperty), {}, {
        value: collectionId
      }));
      if (optionId !== "$option") {
        setOptionsProperty(_objectSpread(_objectSpread({}, optionsProperty), {}, {
          value: optionId
        }));
      }
      if (optionId === APP_CONFIG_OPTION_PROP && optionValue !== "$value") {
        setPropProperty(_objectSpread(_objectSpread({}, propProperty), {}, {
          value: optionValue
        }));
      } else if (optionId === APP_CONFIG_OPTION_FEATURE && optionValue !== "$value") {
        setFeatureProperty(_objectSpread(_objectSpread({}, featureProperty), {}, {
          value: optionValue
        }));
      }
    }
  }, [property.type, property.value]);
  useEffect(function () {
    if (!isInit && property.type) {
      // Required for the new AppConfig use case, causes above useEffect to skip initialisation steps
      setIsInit(true);
    }

    // Wait until isInit is true and integrationProperty has been set
    if (isInit && property.type && property.value && integrationProperty) {
      var _appConfigIntegration3, _appConfigIntegration4;
      var propertyString = property.value.split("::")[1].replace(/[{}]/g, "");
      var propertyArray = propertyString.split(".");
      var serviceId = propertyArray[0];
      var appConfigIntegration = propertyUtils.findSelectedIntegration({
        value: serviceId
      }, toolchainServices);
      var environmentId = (appConfigIntegration === null || appConfigIntegration === void 0 || (_appConfigIntegration3 = appConfigIntegration.parameters) === null || _appConfigIntegration3 === void 0 ? void 0 : _appConfigIntegration3["environment-name"]) || "";
      var collectionId = (appConfigIntegration === null || appConfigIntegration === void 0 || (_appConfigIntegration4 = appConfigIntegration.parameters) === null || _appConfigIntegration4 === void 0 ? void 0 : _appConfigIntegration4["collection-name"]) || "";
      setEnvironmentProperty(_objectSpread(_objectSpread({}, environmentProperty), {}, {
        value: environmentId
      }));
      setCollectionProperty(_objectSpread(_objectSpread({}, collectionProperty), {}, {
        value: collectionId
      }));
    }
  }, [isInit, property.type, integrationProperty]);
  var updateAppConfigProperty = function updateAppConfigProperty(type, value) {
    var newAppConfigString = "".concat(appConfigProperty);
    if (type === APP_CONFIG_INTEGRATION) {
      setIntegrationProperty(_objectSpread(_objectSpread({}, integrationProperty), {}, {
        value: value
      }));
      newAppConfigString = newAppConfigString.replace("${service}", value);
    } else if (type === APP_CONFIG_OPTION) {
      setOptionsProperty(_objectSpread(_objectSpread({}, optionsProperty), {}, {
        value: value
      }));
      newAppConfigString = newAppConfigString.replace("${option}", value);
    } else if (type === APP_CONFIG_PROPERTY) {
      setPropProperty(_objectSpread(_objectSpread({}, propProperty), {}, {
        value: value
      }));
      newAppConfigString = newAppConfigString.replace("${value}", value);
    } else if (type === APP_CONFIG_FEATURE) {
      setFeatureProperty(_objectSpread(_objectSpread({}, featureProperty), {}, {
        value: value
      }));
      newAppConfigString = newAppConfigString.replace("${value}", value);
    }
    if (type !== APP_CONFIG_INTEGRATION && integrationProperty && integrationProperty.value) {
      newAppConfigString = newAppConfigString.replace("${service}", integrationProperty.value);
    }
    if (type !== APP_CONFIG_OPTION && optionsProperty && optionsProperty.value) {
      newAppConfigString = newAppConfigString.replace("${option}", optionsProperty.value);
    }
    if (type !== APP_CONFIG_PROPERTY && propProperty && propProperty.value && optionsProperty.value === APP_CONFIG_OPTION_PROP) {
      newAppConfigString = newAppConfigString.replace("${value}", propProperty.value);
    }
    if (type !== APP_CONFIG_FEATURE && featureProperty && featureProperty.value && optionsProperty.value === APP_CONFIG_OPTION_FEATURE) {
      newAppConfigString = newAppConfigString.replace("${value}", featureProperty.value);
    }
    // Update the redux store
    updateProperty(_objectSpread(_objectSpread({}, property), {}, {
      value: newAppConfigString
    }));
  };
  return isInit ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppConfigIntegrationSelect, {
    findSelectedItem: findSelectedItem,
    integrationProperty: integrationProperty,
    isLoading: isLoadingToolchainServices,
    updateAppConfigProperty: updateAppConfigProperty
  }), /*#__PURE__*/React.createElement(AppConfigEnvironmentValue, {
    environmentProperty: environmentProperty
  }), /*#__PURE__*/React.createElement(AppConfigCollectionValue, {
    collectionProperty: collectionProperty
  }), /*#__PURE__*/React.createElement(AppConfigOptionsSelect, {
    collectionProperty: collectionProperty,
    environmentProperty: environmentProperty,
    findSelectedItem: findSelectedItem,
    integrationProperty: integrationProperty,
    optionsProperty: optionsProperty,
    updateAppConfigProperty: updateAppConfigProperty
  }), /*#__PURE__*/React.createElement(AppConfigPropertySelect, {
    collectionProperty: collectionProperty,
    environmentProperty: environmentProperty,
    findSelectedItem: findSelectedItem,
    integrationProperty: integrationProperty,
    optionsProperty: optionsProperty,
    propProperty: propProperty,
    updateAppConfigProperty: updateAppConfigProperty
  }), /*#__PURE__*/React.createElement(AppConfigFeatureSelect, {
    collectionProperty: collectionProperty,
    environmentProperty: environmentProperty,
    featureProperty: featureProperty,
    findSelectedItem: findSelectedItem,
    integrationProperty: integrationProperty,
    optionsProperty: optionsProperty,
    updateAppConfigProperty: updateAppConfigProperty
  })) : null;
}